import React from 'react';
import { BiSolidUser } from 'react-icons/bi';
import { Button } from '@/components/ui/button';
import useTokenNotifications from '@/hooks/asset/useTokenNotifications';
const TradeButtons = ({
  form,
  token,
  tokenBalance,
  handleSelectTab,
  setIsModalOpen
}) => {
  const {
    showOrder,
    animationKey
  } = useTokenNotifications({
    address: token?.token?.address,
    network: token?.token?.networkId
  });
  return <div className='flex gap-2 w-full justify-between' data-sentry-component="TradeButtons" data-sentry-source-file="TradeButtons.tsx">
      {showOrder && <span key={animationKey} // Use animation key to re-trigger animations
    className={`absolute top-[-40px] left-[30%] w-fit h-[26px] text-[12px] text-black rounded-full px-3 flex items-center bg-[${showOrder.type === 'buy' ? '#34D399' : '#F87171'}] custom-animation`}>
          <BiSolidUser className='mr-1' />
          {showOrder.type === 'buy' ? `Buy: ${showOrder.amount}` : `Sell: ${showOrder.amount}`}
        </span>}

      {!isNaN(tokenBalance) && tokenBalance > 0 && <Button type='button' className='rounded-full h-[56px] bg-[#F87171] hover:bg-[#F87171] text-genius-blue w-[100%]' onClick={() => {
      form.setValue('tradeSide', 'sell');
      handleSelectTab('sell');
      setIsModalOpen(true);
      return;
    }}>
          Sell
        </Button>}

      <Button type='button' className='rounded-full h-[56px] bg-[#34D399] hover:bg-[#34D399] text-genius-blue w-[100%] m-auto mr-1' onClick={() => {
      form.setValue('tradeSide', 'buy');
      handleSelectTab('buy');
      setIsModalOpen(true);
      return;
    }} data-sentry-element="Button" data-sentry-source-file="TradeButtons.tsx">
        Buy
      </Button>
    </div>;
};
export default TradeButtons;